/**
 * Service Worker Registration
 * Registra el service worker para funcionalidad PWA
 */

if ('serviceWorker' in navigator) {
    // Recarga la página cuando el SW activo cambia (nueva versión tomó control)
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
    });

    // Escucha el mensaje SW_UPDATED que envía el SW al activarse
    navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'SW_UPDATED') {
            window.location.reload();
        }
    });

    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then((registration) => {
                console.log('✅ Service Worker registrado:', registration);
            })
            .catch((error) => {
                console.log('❌ Error al registrar Service Worker:', error);
            });
    });
}
